<template>
  <div class="floating-arrows-carousel">
    <v-carousel
      light
      class="mt-n2 mb-2 pb-6"
      :height="height"
      hide-delimiter-background
      :continuous="false"
    >
      <template v-slot:prev="{ on, attrs }">
        <Button
          v-bind="attrs"
          v-on="on"
          fab
          elevation="3"
          icon="mdi-chevron-left"
          size="x-small"
          color="white"
          class="arrow-button"
        />
      </template>
      <template v-slot:next="{ on, attrs }">
        <Button
          v-bind="attrs"
          v-on="on"
          fab
          elevation="2"
          icon="mdi-chevron-right"
          size="x-small"
          color="white"
          class="arrow-button"
        />
      </template>

      <template>
        <slot />
      </template>
    </v-carousel>
  </div>
</template>

<script>
import Button from '@/components/UI/Button.vue'

export default {
  name: 'Carousel',

  props: {
    height: {
      type: String,
      required: true,
    },
  },

  components: {
    Button,
  },
}
</script>

<style lang="scss">
.floating-arrows-carousel {
  &:hover .v-carousel .v-window__next,
  &:hover .v-carousel .v-window__prev {
    opacity: 1;
  }

  .v-carousel .v-window__next {
    right: -32px !important;
  }

  .v-carousel .v-window__prev {
    left: -32px !important;
  }

  .v-carousel .v-window__next,
  .v-carousel .v-window__prev {
    transition: 100ms ease opacity;
    opacity: 0;
  }

  .v-window.v-carousel {
    overflow: visible;
  }
}
</style>
